// Helper
export const StringIsNumber = (value: string): Boolean => !isNaN(Number(value));

// Turn enum into array
export function intEnumToArray<T extends Record<string, string | number>>(enumObject: T): number[] {
  return Object.keys(enumObject)
    .filter((key) => !isNaN(Number(key)))
    .map((key) => Number(key));
}
